import { createSelector } from 'reselect'


 const appMenu = state => state.dashboard.appMenu
 export const getIsAppMenuOpen = createSelector(appMenu, menu => menu.isOpen)
